import { useState, useEffect, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PopupContext } from '../App';


export default function useResetToken() {
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState('');
  const [valid, setValid] = useState(null); // null=loading, true=valid, false=invalid
  const showPopup = useContext(PopupContext);

  useEffect(() => {
    const t = searchParams.get('token');
    setToken(t || '');
    if (!t) {
      setValid(false);
      showPopup('Missing reset token', 'error');
      return;
    }
    // Optionally, you could call a backend endpoint to validate token here
    setValid(true);
  }, [searchParams, showPopup]);

  return { token, valid };
}
